"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeService = void 0;
var tslib_1 = require("tslib");
var common_1 = require("@wix/wix-vod-constants/common");
var env_1 = require("@wix/wix-vod-constants/env");
var parse_url_1 = require("./utils/parse-url");
var YoutubeService = /** @class */ (function () {
    function YoutubeService(httpClient) {
        this.httpClient = httpClient;
        this.MAX_IDS_IN_REQUEST = 50;
        this.channelIdToPlaylistIdMap = new Map();
    }
    YoutubeService.prototype.get = function (url, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params;
            return tslib_1.__generator(this, function (_a) {
                params = typeof window !== 'undefined' &&
                    window.hasOwnProperty('BusinessManagerAPI')
                    ? {
                        artifact: 'wix-vod-library',
                    }
                    : undefined;
                return [2 /*return*/, this.httpClient.get(env_1.PRODUCTION_HOSTS.pixWix + url, tslib_1.__assign({ params: tslib_1.__assign(tslib_1.__assign({}, params), requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.params) }, requestOptions))];
            });
        });
    };
    YoutubeService.prototype.fetchChannels = function (options, requestConfig) {
        options = tslib_1.__assign({ order: 'relevance', ids: [], maxResults: this.MAX_IDS_IN_REQUEST, shouldThrowWhenNoItems: false }, options);
        var params = {
            pageToken: options.cursor,
            order: options.order,
            forUsername: options.userName,
            // send all ids in '&id=1,2,3" format
            id: options.ids && options.ids.length ? options.ids.join(',') : null,
            maxResults: options.maxResults,
            shouldThrowWhenNoItems: options.shouldThrowWhenNoItems,
        };
        return this.get('/youtube/channels', tslib_1.__assign({ params: params }, requestConfig));
    };
    YoutubeService.prototype.fetchPlayLists = function (options, requestConfig) {
        if (options === void 0) { options = {}; }
        var params = {
            shouldThrowWhenNoItems: options.shouldThrowWhenNoItems || false,
            id: options.ids && options.ids.length ? options.ids.join(',') : null,
        };
        return this.get('/youtube/playlists', tslib_1.__assign({ params: params }, requestConfig));
    };
    YoutubeService.prototype.makeChunks = function (ids, size) {
        return ids.reduce(function (acc, id) {
            var lastChunkIndex = acc.length - 1;
            if (acc[lastChunkIndex].length === size) {
                acc.push([id]);
            }
            else {
                acc[lastChunkIndex].push(id);
            }
            return acc;
        }, [[]]);
    };
    YoutubeService.prototype.batchFetch = function (ids, fetcher) {
        var chunks = this.makeChunks(ids, this.MAX_IDS_IN_REQUEST);
        var requests = chunks.map(function (channelIds) { return fetcher(channelIds); });
        return Promise.all(requests);
    };
    YoutubeService.prototype.parseChannelUrl = function (url) {
        return (0, parse_url_1.parseChannelUrl)(url);
    };
    YoutubeService.prototype.parseVideoUrl = function (url) {
        return (0, parse_url_1.parseVideoUrl)(url);
    };
    YoutubeService.prototype.getChannelsByIds = function (ids, requestConfig) {
        var _this = this;
        return this.batchFetch(ids, function (chunk) {
            return _this.fetchChannels({
                ids: chunk,
            }, requestConfig);
        }).then(function (responses) {
            return tslib_1.__assign(tslib_1.__assign({}, responses[0]), { data: {
                    items: responses.reduce(function (acc, response) {
                        return response.data && response.data.items
                            ? acc.concat(response.data.items)
                            : acc;
                    }, []),
                } });
        });
    };
    YoutubeService.prototype.getChannelById = function (id, requestConfig) {
        return this.getChannelsByIds([id], requestConfig).then(function (response) {
            return tslib_1.__assign(tslib_1.__assign({}, response), { data: response.data.items[0] });
        });
    };
    YoutubeService.prototype.getChannelsByUsername = function (userName, requestConfig) {
        return this.fetchChannels({ userName: userName }, requestConfig);
    };
    YoutubeService.prototype.getPlayListsByIds = function (ids, requestConfig) {
        var _this = this;
        // TODO: add shouldThrowWhenNoItems to parameters
        return this.batchFetch(ids, function (chunk) {
            return _this.fetchPlayLists({ ids: chunk }, requestConfig);
        }).then(function (responses) {
            return tslib_1.__assign(tslib_1.__assign({}, responses[0]), { data: {
                    items: responses.reduce(function (acc, response) {
                        return response.data && response.data.items
                            ? acc.concat(response.data.items)
                            : acc;
                    }, []),
                } });
        });
    };
    YoutubeService.prototype.getPlaylistById = function (id, requestConfig) {
        return this.getPlayListsByIds([id], requestConfig).then(function (response) {
            return tslib_1.__assign(tslib_1.__assign({}, response), { data: response.data.items[0] });
        });
    };
    YoutubeService.prototype.getPlaylistIdByChannelId = function (channelId, requestConfig) {
        var _this = this;
        var cachedPlaylistId = this.channelIdToPlaylistIdMap.get(channelId);
        if (cachedPlaylistId) {
            return Promise.resolve(cachedPlaylistId);
        }
        return this.getChannelById(channelId, requestConfig).then(function (_a) {
            var data = _a.data;
            var dta = data;
            var playlistId = dta.contentDetails.relatedPlaylists.uploads;
            _this.channelIdToPlaylistIdMap.set(channelId, playlistId);
            return playlistId;
        });
    };
    YoutubeService.prototype.fetchVideos = function (videoIds, requestConfig) {
        var requestOptions = tslib_1.__assign({ params: {
                id: videoIds.join(','),
            } }, requestConfig);
        return this.get('/youtube/videos', requestOptions);
    };
    YoutubeService.prototype.getVideosByIds = function (videoIds, requestConfig) {
        var _this = this;
        return this.batchFetch(videoIds, function (idsChunk) {
            return _this.fetchVideos(idsChunk, requestConfig);
        }).then(function (responses) {
            return tslib_1.__assign(tslib_1.__assign({}, responses[0]), { data: {
                    items: responses.reduce(function (acc, response) { return acc.concat(response.data.items); }, []),
                } });
        });
    };
    YoutubeService.prototype.doFetchPlaylistItems = function (playlistId, maxResults, pageToken, requestConfig) {
        return this.get('/youtube/playlistitems', tslib_1.__assign({ params: {
                maxResults: maxResults,
                pageToken: pageToken,
                playlistId: playlistId,
            } }, requestConfig));
    };
    YoutubeService.prototype.fetchChannelVideosByPlaylistId = function (_a, requestConfig) {
        var playlistId = _a.playlistId, itemsCount = _a.itemsCount, _b = _a.pageToken, pageToken = _b === void 0 ? '' : _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var items, perPage, lastResponse, publishedItems;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        items = [];
                        perPage = Math.min(itemsCount, this.MAX_IDS_IN_REQUEST);
                        _c.label = 1;
                    case 1: return [4 /*yield*/, this.doFetchPlaylistItems(playlistId, perPage, pageToken, requestConfig)];
                    case 2:
                        lastResponse = _c.sent();
                        publishedItems = lastResponse.data.items.filter(function (item) { return Boolean(item.contentDetails.videoPublishedAt); });
                        items = items.concat(publishedItems);
                        itemsCount = Math.max(itemsCount - publishedItems.length, 0);
                        pageToken = lastResponse.data.nextPageToken;
                        perPage = Math.min(itemsCount, this.MAX_IDS_IN_REQUEST);
                        _c.label = 3;
                    case 3:
                        if (itemsCount && pageToken) return [3 /*break*/, 1];
                        _c.label = 4;
                    case 4:
                        lastResponse.data.items = items;
                        return [2 /*return*/, lastResponse];
                }
            });
        });
    };
    YoutubeService.prototype.getPlaylistItems = function (_a, requestConfig) {
        var externalId = _a.externalId, urlType = _a.urlType, _b = _a.pageToken, pageToken = _b === void 0 ? '' : _b, itemsCount = _a.itemsCount;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(urlType === common_1.URL_TYPES.CHANNEL)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getPlaylistIdByChannelId(externalId, requestConfig)];
                    case 1:
                        externalId = _c.sent();
                        _c.label = 2;
                    case 2: return [2 /*return*/, this.fetchChannelVideosByPlaylistId({
                            playlistId: externalId,
                            itemsCount: itemsCount,
                            pageToken: pageToken !== null && pageToken !== void 0 ? pageToken : undefined,
                        }, requestConfig)];
                }
            });
        });
    };
    YoutubeService.prototype.getCategoryList = function (categoryIds, requestConfig) {
        var ids = categoryIds.join(',');
        return this.get('/youtube/categories', tslib_1.__assign({ params: {
                ids: ids,
            } }, requestConfig));
    };
    YoutubeService.prototype.getVideoById = function (videoId, requestConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, _a, _b;
            var _c, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.fetchVideos([videoId], requestConfig)];
                    case 1:
                        response = _e.sent();
                        _a = [tslib_1.__assign({}, response)];
                        _c = {};
                        _b = [tslib_1.__assign({}, response.data)];
                        _d = {};
                        return [4 /*yield*/, this.fetchCategoryItemsForVideos(response.data.items, requestConfig)];
                    case 2: return [2 /*return*/, tslib_1.__assign.apply(void 0, _a.concat([(_c.data = tslib_1.__assign.apply(void 0, _b.concat([(_d.categoryItems = _e.sent(), _d)])), _c)]))];
                }
            });
        });
    };
    YoutubeService.prototype.fetchCategoryItemsForVideos = function (items, requestConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var categoryIds, uniqueCategoryIds, data, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        categoryIds = items.map(function (item) { return item.snippet.categoryId; });
                        uniqueCategoryIds = Array.from(new Set(categoryIds));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getCategoryList(uniqueCategoryIds, requestConfig)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.items];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    YoutubeService.prototype.fetchChannelItemsForVideos = function (items, requestConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var channelIds, data, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        channelIds = items.map(function (item) { return item.snippet.channelId; });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getChannelsByIds(channelIds, requestConfig)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.items];
                    case 3:
                        e_2 = _a.sent();
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    YoutubeService.prototype.getChannelVideos = function (_a, requestConfig) {
        var externalId = _a.externalId, urlType = _a.urlType, _b = _a.pageToken, pageToken = _b === void 0 ? '' : _b, itemsCount = _a.itemsCount;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, playlistItems, videoIds, videosResponse, videoItems, _c, categoryItems, channelItems;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getPlaylistItems({ externalId: externalId, urlType: urlType, pageToken: pageToken, itemsCount: itemsCount }, requestConfig)];
                    case 1:
                        response = _d.sent();
                        playlistItems = response.data.items;
                        videoIds = playlistItems.map(function (item) { return item.contentDetails.videoId; });
                        return [4 /*yield*/, this.getVideosByIds(videoIds, requestConfig)];
                    case 2:
                        videosResponse = _d.sent();
                        videoItems = videosResponse.data.items;
                        return [4 /*yield*/, Promise.all([
                                this.fetchCategoryItemsForVideos(videoItems, requestConfig),
                                this.fetchChannelItemsForVideos(videoItems, requestConfig),
                            ])];
                    case 3:
                        _c = _d.sent(), categoryItems = _c[0], channelItems = _c[1];
                        return [2 /*return*/, tslib_1.__assign(tslib_1.__assign({}, response), { data: {
                                    playlistItems: playlistItems,
                                    videoItems: videoItems,
                                    channelItems: channelItems,
                                    categoryItems: categoryItems,
                                    nextPageToken: response.data.nextPageToken,
                                    pageInfo: response.data.pageInfo,
                                } })];
                }
            });
        });
    };
    return YoutubeService;
}());
exports.YoutubeService = YoutubeService;
//# sourceMappingURL=youtube.js.map